var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotgovDecorLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 15,
    viewBox: "0 0 433 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3834_151544)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 117.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 139.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 161.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 183.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 205.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 227.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 249.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 271.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 293.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 315.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 337.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 359.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 381.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 403.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 425.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 29.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#B72913"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3834_151544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 433,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotgovDecorLogin);
export default __webpack_public_path__ + "static/media/dotgov-decor-login.08ebc70a37eabf7af55c43ba81fb6e51.svg";
export { ForwardRef as ReactComponent };